import React from 'react';
import {useSheetModal} from "./ModalContext";

const ModalContainer = () => {
    const { modals, closeModal } = useSheetModal();

    const handleDismiss = () => {
        closeModal();
    };

    return (
        <div className="modal-overlay" style={{ display: modals.length > 0 ? 'block' : 'none' }}>
            <div className="modal-container">
                {modals.map((ModalContent, index) => (
                    <div key={index} className="modal-content">
                            <ModalContent handleCloseModal={handleDismiss} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ModalContainer;
